export default __webpack_public_path__ + "checked-symbol.png";